import React from "react";
import { useTranslation } from "react-i18next";
import { BadgeCheckIcon } from "@heroicons/react/solid";

const NPWPServiceCard = ({ item, renderMaintenanceBadge }) => {
  const { t } = useTranslation();
  const IconComponent = item.icon;

  if (!item.isVisible) {
    return null;
  }

  return (
    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
      <div className="group bg-white border border-slate-200/60 rounded-xl p-6 hover:shadow-lg hover:shadow-slate-900/5 hover:border-slate-300/60 transition-all duration-200 ease-in-out hover:-translate-y-1 h-full flex flex-col">
        <div className="flex items-start space-x-4 flex-1">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg flex items-center justify-center text-xl group-hover:from-blue-600 group-hover:to-blue-700 group-hover:text-white transition-all duration-200">
              <IconComponent className="w-6 h-6 text-blue-600 group-hover:text-white" />
            </div>
          </div>
          <div className="flex-1 min-w-0 flex flex-col h-full">
            <div className="flex items-center gap-2 mb-2">
              <h3 className="text-lg font-semibold text-slate-900 group-hover:text-blue-600 transition-colors duration-200">
                {t(item.titleKey)}
              </h3>
              {item.isPremium && (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-500 border border-blue-200">
                  <BadgeCheckIcon className="mr-1 h-3 w-3 text-blue-500" />
                  Premium
                </span>
              )}
              {!item.isEnabled && renderMaintenanceBadge && renderMaintenanceBadge()}
            </div>
            <p className="text-sm text-slate-600 leading-relaxed mb-4 flex-1">
              {t(item.descriptionKey)}
            </p>
            {item.requiresPremium && (
              <p className="text-xs text-gray-400 mb-4">
                {t("2 Successful Checks Per Day")}
              </p>
            )}
            <div className="mt-auto">
              <button
                onClick={item.onClick}
                disabled={!item.isEnabled}
                type="button"
                className={`inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 ${
                  item.isEnabled
                    ? "text-blue-600 bg-blue-50 border border-blue-200/60 hover:bg-blue-600 hover:text-white hover:border-blue-600"
                    : "text-gray-400 bg-gray-100 border border-gray-200 cursor-not-allowed"
                }`}
              >
                {t(item.isEnabled ? "Use" : "unavailable")}
                {item.isEnabled && (
                  <svg 
                    className="ml-2 w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NPWPServiceCard;